// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"ca993dd8","231":"aa814595","516":"99c99bcd","712":"16493a41","905":"a1bbfbc7"}[chunkId] + ".chunk.css";
};